
import React, { useEffect, useState, useRef, } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Switch,
    Select,
    useCRUDController,
    InputNumber,
    Textarea,
    Button,
    Card,
    Divider,
    Typography,
} from '../../ui/ot'
import { useTranslation } from "react-i18next";
import { ItemForm } from "../../Library/views/BackStage/item_form";
import BookImages from "../../Library/components/book_images";
import { X } from "lucide-react"
import dayjs from 'dayjs';

const hiddenSerialReceiveItemFields = [
    'file_id',
    'call_number_source',
    'location',
    'coded_location_qualifier',
    'inventory_number',
    'shelving_control_number',
    'uri',
    'replacement_price',
    'replacement_price_date',
]

const serialAcquisitionSourceOptions = [
    { value: '訂購', label: '訂購' },
    { value: '贈刊', label: '贈刊' },
    { value: '軍刊', label: '軍刊' },
]

const serialItemTypeLabels = ['中文期刊', '西文期刊', '期刊合訂本']

const SerialReceiveForm = ({
    propsForm,
    field,
    onFormFinish = () => { },
    onCoverChanged = () => { },
    keyPrefix = "cataloging.serial_receive",
    notforloan_options
}) => {

    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const axiosMode = Form.useWatch([field?.name ?? '', 'axiosMode'].join('.'), form)
    const isSyncingRef = useRef(false); // 🛡️ 保護 onValuesChange 避免遞迴

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {

        onFormFinish({
            ...values,
        });

    };

    const onValuesChange = (value, { name, type }) => {
        if (isSyncingRef.current) return;
        if (name.includes("planneddate")) {
            const planneddateValue = form.getFieldValue(name);

            const parts = name.replace(/\[(\d+)\]/g, '.$1').split('.');
            const pathToLevel = parts.slice(0, -1);
            pathToLevel.push("item_data");

            const pathToLevelString = pathToLevel.join('.');
            const currentItemData = form.getFieldValue(pathToLevelString) || [];

            const updatedItemData = currentItemData.map(item => ({
                ...item,
                acquisition_date: planneddateValue
            }));

            const isSame = JSON.stringify(currentItemData) === JSON.stringify(updatedItemData);
            if (!isSame) {
                isSyncingRef.current = true;
                form.setFieldValue(pathToLevelString, updatedItemData);
                setTimeout(() => {
                    isSyncingRef.current = false;
                }, 0); // 🔄 等待一次事件循環結束再解除旗標
            }
        }
        if (name.includes("serialseq")) {
          
            const serialseq = form.getFieldValue(name);

            const parts = name.replace(/\[(\d+)\]/g, '.$1').split('.');
            const pathToLevel = parts.slice(0, -1);
            pathToLevel.push("item_data");

            const pathToLevelString = pathToLevel.join('.');
            const currentItemData = form.getFieldValue(pathToLevelString) || [];

            const updatedItemData = currentItemData.map(item => ({
                ...item,
                serial_issue_number: serialseq
            }));

            const isSame = JSON.stringify(currentItemData) === JSON.stringify(updatedItemData);
             
            if (!isSame) {
                isSyncingRef.current = true;
                form.setFieldValue(pathToLevelString, updatedItemData);
                setTimeout(() => {
                    isSyncingRef.current = false;
                }, 0); // 🔄 等待一次事件循環結束再解除旗標
            }
        }
    };



    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };


    useEffect(() => {
        setDataInitialization();
    }, []);


    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                axiosMode={axiosMode}
                                field={field}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={form.setFieldValue}
                                setCount={setCount}
                                keyPrefix={keyPrefix}
                                propsForm={form}
                                onFormFinish={onFormFinish}
                                onCoverChanged={onCoverChanged}
                                notforloan_options={notforloan_options}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    field,
    initialValues = {},
    keyPrefix = "cataloging.serial_receive",
    axiosMode,
    propsForm,
    setFieldValue,
    notforloan_options,
    getAnyFormValue = () => { },
    onFormFinish = () => { },
    onCoverChanged = () => { },
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const tr = (key, defaultValue) => t(key, { defaultValue })
    const receiveSerialStatusOptions = [
        { value: 1, label: tr('expected', '預期') },
        { value: 2, label: tr('arrived', '已到館') },
        { value: 3, label: tr('late', '延遲') },
        { value: 4, label: tr('missing', '缺件') },
        { value: 41, label: tr('missing_never_received', '缺件（未收到）') },
        { value: 42, label: tr('missing_sold_out', '缺件（絕版）') },
        { value: 43, label: tr('missing_damaged', '缺件（損壞）') },
        { value: 44, label: tr('missing_lost', '缺件（遺失）') },
        { value: 7, label: tr('claimed', '已申報') },
        { value: 5, label: tr('not_available', '無供應') },
        { value: 6, label: tr('delete', '刪除') }
    ]
    const fieldPrefix = field?.name ? `${field.name}.` : ''
    const biblionumber = Form.useWatch(`${fieldPrefix}biblionumber`, propsForm)
    const bibCoverImages = Form.useWatch(`${fieldPrefix}bib_cover_images`, propsForm)
    const bibitemIsbn = Form.useWatch(`${fieldPrefix}bibitem_isbn`, propsForm)
    const bibTitle = Form.useWatch(`${fieldPrefix}bib_title_subtitle`, propsForm)
    let bookImageData = Array.isArray(bibCoverImages)
        ? bibCoverImages.map((file_id) => ({ file_id }))
        : []
    if (bookImageData.length === 0) {
        bookImageData = [{
            src: `https://media.taaze.tw/showLargeImageByIsbn.ashx?isbn=${bibitemIsbn || ""}`,
        }]
    }

    return (
        <>
            <Row>
                <Col xxl={3} xl={3} lg={3} md={4} sm={6} xs={24} >
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'file_id']}
                        fieldKey={[field?.fieldKey ?? '', 'file_id']}
                        // label={t('subscriptionid')}
                        // rules={[{ required: true, message: t('please_input_item') }]}
                        hidden={true}
                    >
                        <div></div>
                    </Form.Item>
                    <BookImages
                        bookImageData={bookImageData}
                        biblionumber={biblionumber}
                        title={bibTitle}
                        isbn={bibitemIsbn}
                        onChanged={(result) => {
                            const editName = field?.name !== undefined
                                ? `${field.name}.bib_cover_images`
                                : 'bib_cover_images'
                            setFieldValue(editName, result.fileIds)
                            onCoverChanged(result)
                        }}
                    />
                </Col>
                <Col xxl={21} xl={21} lg={21} md={20} sm={18} xs={24}>
                    <Row>
                        <Col span={24} >
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'biblionumber']}
                                fieldKey={[field?.fieldKey ?? '', 'biblionumber']}
                                label={tr('biblionumber', '書目編號')}
                                rules={[{ required: true, message: tr('please_input_item', '請輸入項目') }]}
                                hidden={true}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'subscriptionid']}
                                fieldKey={[field?.fieldKey ?? '', 'subscriptionid']}
                                label={tr('subscriptionid', '訂閱ID')}
                                rules={[{ required: true, message: tr('please_input_item', '請輸入項目') }]}
                                hidden={true}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col xxl={4} xl={6} lg={8} md={8} sm={12} xs={24}  >
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'serialseq']}
                                fieldKey={[field?.fieldKey ?? '', 'serialseq']}
                                label={tr('serialseq', '期刊序號')}
                                labelCol={24}
                                wrapperCol={24}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col xxl={4} xl={6} lg={8} md={8} sm={12} xs={24}  >
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'publisheddate']}
                                fieldKey={[field?.fieldKey ?? '', 'publisheddate']}
                                label={tr('publisheddate', '出版日期')}
                                labelCol={24}
                                wrapperCol={24}

                            >
                                <Input type="date" />
                            </Form.Item>
                        </Col>
                        <Col xxl={4} xl={6} lg={8} md={8} sm={12} xs={24} >
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'publisheddatetext']}
                                fieldKey={[field?.fieldKey ?? '', 'publisheddatetext']}
                                label={tr('publisheddatetext', '出版日期（文字）')}
                                labelCol={24}
                                wrapperCol={24}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xxl={4} xl={6} lg={8} md={8} sm={12} xs={24}  >
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'planneddate']}
                                fieldKey={[field?.fieldKey ?? '', 'planneddate']}
                                label={tr('planneddate', '到刊日期')}
                                labelCol={24}
                                wrapperCol={24}
                            >
                                <Input
                                    type="date"
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={4} xl={6} lg={8} md={8} sm={12} xs={24} >
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'status']}
                                fieldKey={[field?.fieldKey ?? '', 'status']}
                                label={tr('status', '狀態')}
                                labelCol={24}
                                wrapperCol={24}
                            >
                                <Select
                                    allowClear={true}
                                    options={receiveSerialStatusOptions}
                                />
                            </Form.Item>
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'old_status']}
                                fieldKey={[field?.fieldKey ?? '', 'old_status']}
                                // label={t('status')}
                                labelCol={24}
                                wrapperCol={24}
                                hidden={true}
                            >
                                <Select
                                    allowClear={true}
                                    options={receiveSerialStatusOptions}
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={4} xl={6} lg={8} md={8} sm={12} xs={24}  >
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'notes']}
                                fieldKey={[field?.fieldKey ?? '', 'notes']}
                                label={tr('notes', '備註')}
                                labelCol={24}
                                wrapperCol={24}
                            >
                                <Input />
                            </Form.Item>
                        </Col>


                        {/* <Col span={4} >
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'claimdate']}
                                fieldKey={[field?.fieldKey ?? '', 'claimdate']}
                                label={t('claimdate')}
                            >

                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={4} >
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'claims_count']}
                                fieldKey={[field?.fieldKey ?? '', 'claims_count']}
                                label={t('claims_count')}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                     
                        <Col span={4} >
                            <Form.Item
                                {...field}
                                name={[field?.name ?? '', 'routingnotes']}
                                fieldKey={[field?.fieldKey ?? '', 'routingnotes']}
                                label={t('routingnotes')}

                            >
                                <Input />
                            </Form.Item>
                        </Col> */}
                    </Row>
                </Col>
                <Col span={24}>
                    <Divider > <Typography.Title level={4}>{tr('collection_information', '館藏資訊')}</Typography.Title></Divider>
                    <Form.List
                        {...field}
                        fieldKey={[field?.fieldKey ?? '', 'item_data']}
                        name={[field?.name ?? '', 'item_data']}
                    >
                        {(itemfields, { add, remove }) => {
                            let not_for_loan_status = notforloan_options?.find((ele) => true)?.authorised_value
                            return (<Row gutter={[8, 8]}>

                                <Col span={24}>
                                    <Row gutter={[8, 8]} justify="end">
                                        <Col>
                                            <Button onClick={() => {
                                                add({
                                                    biblio_id: field?.biblionumber,
                                                    serialid: field?.serialid,
                                                    serial_issue_number: field?.serialseq,
                                                    biblionumber: field?.biblionumber,
                                                    acquisition_date: dayjs().format("YYYY-MM-DD"),
                                                    not_for_loan_status: not_for_loan_status,
                                                    "materials_notes": "",
                                                    "home_library_id": field?.branchcode,
                                                    "holding_library_id": field?.branchcode,
                                                    "item_type_id": null,
                                                    "acquisition_source": null,
                                                    "coded_location_qualifier": null,
                                                    "purchase_price": null,
                                                    "inventory_number": null,
                                                    "callnumber": null,
                                                    "external_id": null,
                                                    "copy_number": null,
                                                    "uri": null,
                                                    "replacement_price": null,
                                                    "replacement_price_date": null,
                                                    "internal_notes": null,
                                                    "public_notes": null,
                                                })
                                            }}>
                                                新增館藏
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                                {
                                    itemfields?.map((itemfield, index) => {
                                        return <Col span={24}>
                                            <Card size={"small"}  >
                                                <Row gutter={[4, 4]}>
                                                    <Col span={24}>
                                                        <Row justify="end">
                                                            <Col>
                                                                <Button
                                                                    size="icon"
                                                                    type="danger"
                                                                    onClick={() => {
                                                                        remove(index)
                                                                    }}
                                                                ><X /></Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col span={24}>
                                                        <ItemForm
                                                            key={itemfield?.id}
                                                            field={itemfield}
                                                            propsForm={propsForm}
                                                            onFormFinish={onFormFinish}
                                                            hiddenFields={hiddenSerialReceiveItemFields}
                                                            acquisitionSourceOptions={serialAcquisitionSourceOptions}
                                                            allowedItemTypeLabels={serialItemTypeLabels}
                                                            syncCopyNumberOnGenerate={false}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    })
                                }

                            </Row>)
                        }}
                    </Form.List>
                </Col>
            </Row>
        </>
    );
};





export default SerialReceiveForm;
